import React from "react";

const PageHeader = ({ title, description, actions, eyebrow, className = "" }) => {
    return (
        <div
            className={`flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between ${className}`}
        >
            <div>
                {eyebrow && (
                    <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-brand-600">
                        {eyebrow}
                    </p>
                )}
                <h1 className="text-2xl font-semibold tracking-tight text-ink-900 sm:text-3xl">
                    {title}
                </h1>
                {description && <p className="mt-1 text-sm text-ink-500">{description}</p>}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
    );
};

export default PageHeader;
